<div [ngClass]="{'huna-select-form-field':isTouched_,'error-color':errorIsSet}" class="w100 ">
  <form [formGroup]="form">
    @switch (type) {
      @case (typeForm.INPUT_TEXT) {
        <mat-form-field appearance="fill" class="w100">
          <mat-label>
            {{ titleTraduction|translate }}
          </mat-label>
          <input matInput formControlName="value">
          @if (form.get('value')!=null&&form.get('value')?.errors!=null) {
            <mat-error>{{
              getErrorByObject(form.get('value')?.errors!) }}
            </mat-error>
          }
          <ng-container matSuffix [ngTemplateOutlet]="buttonClearOrCustom"
            [ngTemplateOutletContext]="{visualizeButton:visualizedClearButton}">
          </ng-container>
        </mat-form-field>
      }
      @case (typeForm.INPUT_NUMBER) {
        <mat-form-field appearance="fill" class="w100 text">
          <mat-label class="text">
            {{ titleTraduction|translate }}
          </mat-label>
          <input matInput formControlName="value" type="number" step="0.5" [attr.min]="min" [attr.max]="max" (blur)="clampToRange()">
          @if (errorIsSet && !rangeError) {
            <mat-hint class="text">{{ getErrorByObject(form.get('value')?.errors!) }}
            </mat-hint>
          } @else if (hasRange) {
            <mat-hint class="text" [class.text-color-warn]="rangeError">
              <ng-container [ngTemplateOutlet]="RANGEHINT"></ng-container>
            </mat-hint>
          }
          <ng-container matSuffix [ngTemplateOutlet]="buttonClearOrCustom"
            [ngTemplateOutletContext]="{visualizeButton:visualizedClearButton}">
          </ng-container>
        </mat-form-field>
      }
      @case (typeForm.INPUT_INTEGER) {
        <div [ngClass]="{'error-color':errorIsSet}" class="w100">
          <mat-form-field appearance="fill" class="w100 text ">
            <mat-label class="text">
              {{ titleTraduction|translate }}
            </mat-label>
            <input matInput formControlName="value" type="number" step="1" [attr.min]="min" [attr.max]="max" (blur)="clampToRange()">
            @if (form.get('value')!=null&&form.get('value')?.errors!=null&&!rangeError) {
              <mat-error>{{
                getErrorByObject(form.get('value')?.errors!) }}
              </mat-error>
            } @else if (hasRange) {
              <mat-hint class="text" [class.text-color-warn]="rangeError">
                <ng-container [ngTemplateOutlet]="RANGEHINT"></ng-container>
              </mat-hint>
            }
            <ng-container matSuffix [ngTemplateOutlet]="buttonClearOrCustom"
              [ngTemplateOutletContext]="{visualizeButton:visualizedClearButton}">
            </ng-container>
          </mat-form-field>
        </div>
      }
      @case (typeForm.CHECKBOX) {
        <div class="container-check-box-widget background-color"
          [ngClass]="{'error-button-yesOrNotCheck':isInError('required')}">
          <div style="padding: 10px 5px;" class="flex-between-center w100">
            <p style="margin:5px 0  0 7px;max-width: calc(100% - 110px)">
              {{ titleTraduction|translate }}
            </p>
            <div style="width: 100px">
              <mat-checkbox formControlName="value">
              </mat-checkbox>
              <ng-container matSuffix [ngTemplateOutlet]="buttonClearOrCustom"
                [ngTemplateOutletContext]="{visualizeButton:visualizedClearButton}">
              </ng-container>
            </div>
          </div>
        </div>
      }
      @case (typeForm.ONOFFBUTTON) {
        <div class="container-check-box-widget background-color"
          [ngClass]="{'error-button-yesOrNotCheck':isInError('required')}">
          <div style="padding: 10px 5px;" class="flex-between-center w100">
            <p style="margin:5px 0  0 7px;max-width: calc(100% - 110px)">
              {{ titleTraduction|translate }}
            </p>
            <div style="width: 100px">
              <app-on-off-slide-button formControlName="value">
              </app-on-off-slide-button>
            </div>
          </div>
        </div>
      }
      @case (typeForm.PUSH_BUTTON) {
        <div class="container-check-box-widget"
          [ngClass]="{'error-button-yesOrNotCheck':isInError('required')}">
          <div style="padding: 10px " class="flex-between-center w100-margin-5">
            @if (iconPushButtonIsSet) {
              <p style="margin:5px 0  5px 7px;">
                {{ titleTraduction|translate }}
              </p>
            }
            <button mat-flat-button color="accent" (click)="clickButton()"
              [disabled]="form.get('value')?.disabled!">
              @if (iconPushButtonIsSet) {
                @if (iconPushButton?.icon) {
                  <mat-icon>{{ iconPushButton?.icon }}</mat-icon>
                } @else {
                  <mat-icon [svgIcon]="iconPushButton?.svgIcon!"></mat-icon>
                }
              } @else {
                {{ titleTraduction|translate }}
              }
            </button>
          </div>
        </div>
      }
      @case (typeForm.DATE) {
        <div class="flex-center-center w100-margin flex-direction-column" appClickOutiside
          (clickOutside)="showCalendar=false">
          <mat-card style="border-radius: 20px;width: 300px;max-width: 100%">
            <mat-card-header>
              @if (form.get('value')?.value) {
                <mat-card-subtitle style="margin-bottom: 0;">
                  {{ titleTraduction|translate }}
                </mat-card-subtitle>
              }
            </mat-card-header>
            <mat-card-content>
              <div class="flex-around-center w100 flex-direction-row">
                @if (form.get('value')?.value ) {
                  {{ form.get('value')?.value|customDate:'medium'|async }}
                } @else {
                  {{ titleTraduction|translate }}
                }
                <button mat-icon-button color="primary"
                  (click)="$event.stopPropagation();showCalendar=!showCalendar"
                  [disabled]="isDisabled">
                  <mat-icon>edit_calendar</mat-icon>
                </button>
              </div>
            </mat-card-content>
          </mat-card>
          @if (showCalendar&&form.get('value')?.enabled) {
            <mat-card style="width: 300px;margin-top:5px "
              (click)="$event.stopPropagation()">
              <mat-card-header>
                <mat-card-subtitle> {{ titleTraduction|translate }}</mat-card-subtitle>
              </mat-card-header>
              <mat-card-content>
                <mat-calendar [minDate]="minDate" (selectedChange)="changeDate($event)"
                  [selected]="form.get('value')?.value">
                </mat-calendar>
              </mat-card-content>
            </mat-card>
          }
        </div>
      }
      @case (typeForm.GEO_POINT) {
        <!--                <mat-card class="flex-around-center w100 flex-direction-row">-->
        <!--                    <mat-card-header>-->
        <!--                        <mat-card-subtitle style="margin-bottom: 5px">{{titleTraduction|translate}}</mat-card-subtitle>-->
      <!--                    </mat-card-header>-->
      <!--                    <mat-card-content>-->
      <!--                        <mat-form-field appearance="fill" style="min-width: 150px;width: calc(50% - 10px)">-->
      <!--                            <mat-label>-->
      <!--                                {{'latitude'|translate}}-->
    <!--                            </mat-label>-->
    <!--                            <input-->
    <!--                                    [disabled]="isDisabled"-->
    <!--                                    matInput type="number" (change)="changeLatLng('lat',$event)"-->
    <!--                                    [value]="getValueLatLng('lat')" step="0.0000000001">-->
  <!--                        </mat-form-field>-->
  <!--                        <mat-form-field appearance="fill" style="min-width: 150px;width: calc(50% - 10px)">-->
  <!--                            <mat-label>-->
  <!--                                {{'longitude'|translate}}-->
<!--                            </mat-label>-->
<!--                            <input matInput type="number" (change)="changeLatLng('lng',$event)"-->
<!--                                   [value]="getValueLatLng('lng')" step="0.0000000001"-->
<!--                                   [disabled]="isDisabled"-->
<!--                            >-->
<!--                        </mat-form-field>-->
<!--                    </mat-card-content>-->
<!--                </mat-card>-->
<app-search-location-form-field title="{{'location'|translate}}" formControlName="value">
</app-search-location-form-field>
}
@case (typeForm.ELENCO_VINCOLATO) {
  @if (possibleValuesIsSet) {
    <mat-form-field appearance="fill" class="w100">
      <mat-label>
        {{ titleTraduction|translate }}
      </mat-label>
      <mat-select formControlName="value">
          @for (possibleValue of possibleValues; track possibleValue.valueForm) {
          <mat-option value="{{possibleValue.valueForm}}">
            {{ possibleValue?.traduction! | translate }}
          </mat-option>
        }
      </mat-select>
      <ng-container matSuffix [ngTemplateOutlet]="buttonClearOrCustom"
        [ngTemplateOutletContext]="{visualizeButton:visualizedClearButton}">
      </ng-container>
    </mat-form-field>
  }
}
@case (typeForm.ELENCO_APERTO) {
  @if (possibleValues!=null) {
    <app-auto-complete-form class="width-form-field"
      [title]="titleTraduction|translate" [items]="possibleValues" appearance="fill"
      [hiddenClearButton]="true" formControlName="value">
      <div suffix>
        <ng-container matSuffix [ngTemplateOutlet]="buttonClearOrCustom"
          [ngTemplateOutletContext]="{visualizeButton:visualizedClearButton}">
        </ng-container>
      </div>
    </app-auto-complete-form>
  }
}
@case (typeForm.ELENCO_WITH_FILTER) {
  <app-form-field-select-with-filter formControlName="value" [title]="titleTraduction|translate"
    [possibleValues]="possibleValues" [idsUsed]="idsUsed">
  </app-form-field-select-with-filter>
}
@case (typeForm.IMAGE) {
  <div class="flex-around-center w100 ">
    <app-upload-file class="w100" accept="image/jpeg,image/jpg,image/png" formControlName="value"
      title="{{titleTraduction|translate}}">
    </app-upload-file>
  </div>
}
@case (typeForm.FILE) {
  <div class="flex-around-center w100 ">
    <!--                <ngx-dropzone-->
    <!--                        [disabled]="isDisabled"-->
    <!--                        (change)="onLoadFile($event.addedFiles)"-->
    <!--                        class="drop-zone-item-background ngx-drop-zone-color"-->
    <!--                        accept="*"-->
    <!--                >-->
    <!--                    <ngx-dropzone-label class="w100">-->
    <!--                        <div class="flex-around-center flex-direction-column w100 "-->
    <!--                             [ngClass]="{'error-button-yesOrNotCheck':isInError('required')}"-->
    <!--                        >-->
    <!--                            <ng-container *ngIf="!fileIsSet;else fileIsSetted">-->
    <!--                                <div class="flex-start-start flex-direction-column" style="width: calc(100% - 51px)">-->
    <!--                                    <span style="text-align: start;font-size: 14px;margin-bottom: 3px;margin-left: 20px">{{titleTraduction|translate}}</span>-->
    <!--                                    <div class="w100"-->
  <!--                                         style="text-align: center">{{ 'fileManager.copyFile' | translate}}</div>-->
<!--                                </div>-->
<!--                            </ng-container>-->
<!--                            <ng-template #fileIsSetted>-->
<!--                                <div class="flex-around-center flex-direction-row w100">-->
<!--                                    <mat-card style="min-width: 50px;min-height:40px;background: rgba(33,128,218,0.44)">-->
<!--                                        <div style="position: absolute;top: -10px;right: -8px;z-index: 10000">-->
<!--                                            <button mat-icon-button-->
<!--                                                    (click)="$event.stopPropagation();unsetValueFile()">-->
<!--                                                <mat-icon style="color: white">cancel</mat-icon>-->
<!--                                            </button>-->
<!--                                        </div>-->
<!--                                        <h3 style="color: white;">{{form.get('value')?.value!.ext}}</h3>-->
<!--                                    </mat-card>-->
<!--                                    <h4>{{form.get('value')?.value!.name}}</h4>-->
<!--                                </div>-->
<!--                            </ng-template>-->
<!--                        </div>-->
<!--                    </ngx-dropzone-label>-->
<!--                </ngx-dropzone>-->
</div>
}
@case (typeForm.CUSTOM_FORM_ARRAY) {
  <button mat-flat-button color="accent" [matBadge]="this.form.get('value')?.value!.values.length"
    (click)="clickCustomType()">
    {{ titleTraduction|translate }}
  </button>
}
@case (typeForm.ELENCO_RADIO_BUTTON) {
  <mat-card>
    <mat-card-content>
      <label id="radio-group-label" style="margin-bottom: 5px;display: flex!important;"
        class="flex-start-center flex-direction-row">
        <div>
          {{ titleTraduction|translate }}
        </div>
        <button mat-icon-button (click)="$event.stopPropagation();unsetValue()">
          <mat-icon>clear</mat-icon>
        </button>
      </label>
      <mat-radio-group formControlName="value" aria-labelledby="radio-group-label"
        class="w100 flex-evenly-center flex-direction-row">
        @for (possibleValue of possibleValues; track possibleValue.valueForm) {
          <mat-radio-button
            value="{{possibleValue.valueForm}}">
            {{ possibleValue?.traduction! | translate }}
          </mat-radio-button>
        }
      </mat-radio-group>
      @if (form.get('value')!=null&&form.get('value')?.errors!=null) {
        <mat-error>{{
          getErrorByObject(form.get('value')?.errors!) }}
        </mat-error>
      }
    </mat-card-content>
  </mat-card>
}
@case (typeForm.INPUT_ARRAY_TEXTS) {
  <app-input-text-array-form-field formControlName="value">
  </app-input-text-array-form-field>
}
@case (typeForm.INPUT_ARRAY_CHIPS) {
  <app-form-field-chips [title]="titleTraduction|translate" formControlName="value">
  </app-form-field-chips>
}
@case (typeForm.INPUT_KEY_VALUES) {
  <app-key-values-field formControlName="value" [title]="titleTraduction|translate"
    [possibleValues]="possibleValues??[]" [specials]="specialValues">
  </app-key-values-field>
}
@case (typeForm.EXTERNAL_INFO) {
  <app-form-field-external-info [title]="titleTraduction|translate" [elements]="elements"
    [sensorsData]="sensorsData" formControlName="value">
  </app-form-field-external-info>
}
@case (typeForm.EXTERNAL_COMMAND) {
  <app-form-field-external-command [elements]="elements"
    [title]="titleTraduction|translate"
    formControlName="value">
  </app-form-field-external-command>
}
@case (typeForm.OTHERINHTML) {
}
}
</form>
</div>

<ng-template #buttonClearOrCustom let-visualize='visualizeButton'>
  @if (visualize) {
    <button mat-icon-button matSuffix (click)="$event.stopPropagation();unsetValue()">
      <mat-icon>clear</mat-icon>
    </button>
  } @else {
    <ng-content select="[suffix]">
    </ng-content>
  }
</ng-template>

<ng-template #RANGEHINT>
  @if (min != null) {
    {{ 'min' | translate }} {{ min }}
  }
  @if (min != null && max != null) {
    ·
  }
  @if (max != null) {
    {{ 'max' | translate }} {{ max }}
  }
</ng-template>